import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useMasters() {
  const { version } = useAuth();
  const [data, setData] = useState({ dse: [], fl: [], party: [], retailer: [], schemes: [], accounts: [], rates: {}, distributors: [] });
  const [tick, setTick] = useState(0);

  useEffect(() => {
    Promise.all([api.get("/masters/dse"), api.get("/masters/fl"), api.get("/settings"), api.get("/fund-accounts"), api.get("/distributors"), api.get("/masters/party"), api.get("/masters/retailer")])
      .then(([d, f, s, a, ds, p, r]) => setData({ dse: d.data, fl: f.data, party: p.data, retailer: r.data, schemes: s.data.schemes, accounts: a.data, distributors: ds.data,
        rates: { vi: Number(s.data.vi_extra_rate), dse: Number(s.data.dse_extra_rate), retailer: Number(s.data.retailer_margin_rate) } }))
      .catch(() => {});
  }, [version, tick]);

  return { ...data, reload: () => setTick((t) => t + 1) };
}
